import { useLocation } from 'react-router-dom'
import React, { useEffect } from 'react'
import banner from '../../assets/images/Terms of Service Banner.png'
import aos from 'aos';
import 'aos/dist/aos.css'
const TermsOfService = () => {
  const { top } = useLocation();
  useEffect(()=>{
    aos.init({ duration: 1000 });
    window.scrollTo(0,0);
  },[top])

  return (
    <>
    <div className="container-fluid gx-0">
      <img className='img-fluid' data-aos="zoom-in" src={banner} alt="" />
    </div>
    <div className="container py-lg-5 py-5">
     
      <div className="row py-lg-5 py-3">
        <div className="col-12" data-aos="zoom-in">
          <p>Effective Date: 28/10/2024</p>
          <p>Last Updated: 28/10/2024</p>
          <p>Please read these Terms of Service carefully before using OREUS Lifesciences  website, products, or services.</p>
        </div>
      </div>

      <div className="row py-lg-5 py-3">
          <div className="col-lg-6 col-md-6 mb-lg-5 mb-3" data-aos="zoom-in">
            <h5>Introduction</h5>
            <p>Oreus Lifesciences, provides pharmaceutical products and services to healthcare professionals, patients, and logistics partners. These Terms of Service govern your use of our website, products, and services.</p>
          </div>

          <div className="col-lg-6 col-md-6 mb-lg-5 mb-3" data-aos="zoom-in">
            <h5>Definitions</h5>
            <ol>
              <li>"Website" means www.oreus.com</li>
              <li>"Products" means pharmaceutical products and related services.</li>
              <li>"Services" means customer support, product information, and other related services.</li>
              <li>"User" means you, the website visitor or customer.</li>
            </ol>
          </div>

          <div className="col-lg-6 col-md-6 mb-lg-5 mb-3" data-aos="zoom-in">
            <h5>Use of Website and Services</h5>
            <ol>
              <li>You must be at least 18 years old to use our website and services.</li>
              <li>You agree to provide accurate and complete information.</li>
              <li> You are responsible for maintaining confidentiality of your account information.</li>
              
            </ol>
          </div>

          <div className="col-lg-6 col-md-6 mb-lg-5 mb-3" data-aos="zoom-in">
            <h5>Intellectual Property</h5>
            <ol>
              <li>All content on our website is proprietary and protected by copyright laws.</li>
              <li>You may not reproduce, distribute, or display any content without permission.</li>
              
            </ol>
          </div>

          <div className="col-lg-6 col-md-6 mb-lg-5 mb-3" data-aos="zoom-in">
              <h5>Product Information and Ordering</h5>
              <ol>
                <li>Product information is for informational purposes only.</li>
                <li>You must consult a healthcare professional before ordering products.</li>
                <li>Orders are subject to availability and pricing changes.</li>
              </ol>
          </div>

          <div className="col-lg-6 col-md-6 mb-lg-5 mb-3" data-aos="zoom-in">
            <h5>Payment and Refund</h5>
            <ol>
              <li>Payment terms are net 21 days.</li>
              <li>Refunds will be processed within 30 days.</li>
            </ol>
          </div>

          <div className="col-lg-6 col-md-6 mb-lg-5 mb-3" data-aos="zoom-in">
            <h5>Disclaimer and Limitation of Liability</h5>
            <ol>
              <li>Our website and services are provided "as is" and "as available."</li>
              <li>We disclaim all warranties, express or implied.</li>
              <li>Our liability is limited to net cost or the purchase price.</li>
            </ol>
          </div>

          <div className="col-lg-6 col-md-6 mb-lg-5 mb-3" data-aos="zoom-in">
            <h5>Indemnification</h5>
            <p>You agree to indemnify and hold harmless Oreus Lifesciences and its affiliates.</p>
          </div>
          <div className="col-lg-6 col-md-6 mb-lg-5 mb-3" data-aos="zoom-in">
            <h5>Termination</h5>
            <p>We reserve the right to terminate or suspend your account.</p>
          </div>
          <div className="col-lg-6 col-md-6 mb-lg-5 mb-3" data-aos="zoom-in">
            <h5>Governing Law</h5>
            <p>These Terms of Service are governed by and construed in accordance with Uttar Pradesh laws.</p>
          </div>
          <div className="col-lg-6 col-md-6 mb-lg-5 mb-3" data-aos="zoom-in">
            <h5>Changes to Terms</h5>
            <p>We reserve the right to update these Terms of Service.</p>
          </div>
          <div className="col-lg-6 col-md-6" data-aos="zoom-in">
            <h5>Contact Us</h5>
            <h6>For questions or concerns, please contact</h6>
            <p>OREUS LIFESCIENCES</p>
            <p>Email : oreuslife@gmail.com</p>
            <p>Phone Number :+91 97600 11544, +91 75000 82082</p>
          </div>
      </div>
      <div className="row">
        <div className="col-12" data-aos="zoom-in">
        <p>By using our website and services, you agree to these Terms of Service.</p>
        </div>
      </div>
    </div>
    </>
  )
}

export default TermsOfService
